import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthInput } from "../../../components/AuthInput/input";
import { YellowButton } from "../../../components/UI/Button/button";
import classes from "../index.module.css";
import { checkMail } from "../../../utils/functions";
import { postSupportComplaint as postTalentSupportComplaint } from "../../../services/talentCalls";
import { postSupportComplaint as postClientSupportComplaint } from "../../../services/clientCalls"; 
import confusedStan from "../../../assets/illustrations/approving-stan-blue.png";
import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";

const LogABug = () => {
  const location = useLocation();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    email: "",
    page: "",
    issue: "",
  });

  // check if current path is under /talent or /client
  const getUserType = () => {
    if (location.pathname.includes("/talent")) return "talent";
    if (location.pathname.includes("/client")) return "client";
    return "unknown";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        supportType: "LogABug", // fixed
        fullName: data.name,
        email: data.email,
        pageOrFeature: data.page,
        message: data.issue
      };

      const userType = getUserType();

      if (userType === "talent") {
        await postTalentSupportComplaint(payload);
      } else if (userType === "client") {
        await postClientSupportComplaint(payload);
      } else {
        throw new Error("Unknown user type in pathname");
      }

      setShowSuccessModal(true);
      setData({ name: "", email: "", page: "", issue: "" });
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const props1 = {
    type: "text",
    label: "Full Name*",
    placeholder: "Jane Doe",
    value: data.name,
    onChange: (e) =>
      setData((prevState) => ({ ...prevState, name: e.target.value })),
    isValid: data.name?.length > 3,
    text: "Invalid Full Name",
    name: "Full Name",
    id: "name",
  };

  const props2 = {
    type: "email",
    label: "Email Address*",
    placeholder: "Janedoe@awasource.com",
    value: data.email,
    onChange: (e) =>
      setData((prevState) => ({ ...prevState, email: e.target.value })),
    isValid: checkMail(data.email),
    text: "Invalid Email Address",
    name: "email",
    id: "email",
  };

  const props4 = {
    type: "text",
    placeholder: "Sign up Page, Login Page, etc.",
    value: data.page,
    onChange: (e) =>
      setData((prevState) => ({ ...prevState, page: e.target.value })),
    isValid: data.page?.length > 3,
    text: "Invalid Response",
    name: "error_page",
    id: "page",
  };

  return (
    <div className={classes.main}>
      {isSubmitting && <FullScreenLoader />}
      <h3 className="t-24 mb-md">Log a Bug</h3>
      <div>
        <form onSubmit={handleSubmit}>
          <p className="mb-md t-md">
            Please use this to tell us about an issue you noticed
          </p>
          <AuthInput {...props1} />
          <AuthInput {...props2} />
          <label htmlFor="page">Page or feature where bug was found*</label>
          <AuthInput {...props4} />
          <label>Tell us about the issue*</label>
          <textarea
            placeholder=""
            value={data.issue}
            onChange={(e) =>
              setData((prevState) => ({ ...prevState, issue: e.target.value }))
            }
          ></textarea>
          <span className={classes.info}>
            Any information you provide is in accordance with our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> &
            <Link to="/terms-of-service"> Terms of Use</Link>
          </span>
          <YellowButton
            disabled={
              !data.name || !checkMail(data.email) || !data.page || !data.issue || isSubmitting
            }
            type="submit"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </YellowButton>
        </form>
      </div>

      {showSuccessModal && (
        <ErrorModal
          isModalOpen={showSuccessModal}
          setModalOpen={setShowSuccessModal}
        >
          <div
            style={{
              backgroundColor: '#0A0F8F',
              padding: '50px 110px',
              borderRadius: '8px',
              textAlign: 'center',
              color: 'white',
              width: '100%',
              boxSizing: 'border-box'
            }}
          >
            <img
              src={confusedStan}
              alt="Success confirmation"
              style={{ width: '150px', marginBottom: '20px' }}
            />
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>
              Thanks for your feedback
            </p>
            <p style={{ fontSize: '14px', lineHeight: '1.5' }}>
              We will get back to you soon.
            </p>
          </div>
        </ErrorModal>
      )}
    </div>
  );
};

export default LogABug;
